export default __webpack_public_path__ + "static/media/wheels.3fe67bef.jpeg";